import * as React from 'react';
import { Link as InternalLink } from 'widgets-for-react'
import { DecorativeIcon } from './spaarneIcons';
import { isEmbedded } from './embed';

export const isUrlExternal = (url: string): boolean => {
  if (url !== '' && !url.startsWith('/')) {
    const currentUrlHost = window.location.host
    if (
      (url.toLowerCase().includes('https://') || url.toLowerCase().includes('http://')) &&
      new URL(url).host != currentUrlHost
    ) {
      return true
    }
    return false
  } else {
    return false
  }
}

export const isUrlAbsolute = (url: string): boolean => {
  if (!url) return false
  const currentUrlHost = window.location.host
  return (
    (url.toLowerCase().includes('https://') || url.toLowerCase().includes('http://')) &&
    new URL(url).host == currentUrlHost
  )
}

export const Link = (
  props: {
    url: string
    children: React.ReactNode
    additionalOnClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void 
  } & Omit<React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>, 'href'>
) => {
  const { url, children, additionalOnClick, ...rest } = props
  
  return isUrlAbsolute(props.url) ? (
    <a {...rest} href={props.url} rel={props.rel ? props.rel : 'noopener noreferrer'}>
      {children}
    </a>
  ) : isUrlExternal(props.url) ||
    /.pdf$/.test(props.url) ||
    /.docx?$/.test(props.url) ||
    /.pptx?$/.test(props.url) ||
    /^\/api\/v1\/patient-folders/.test(props.url) ||
    /.xlsx?$/.test(props.url) ? (
    <a {...rest} href={props.url} target="_blank" rel={props.rel ? props.rel : 'noopener noreferrer'}>
      {children}
      <span className="sr-text">(Opent in nieuw venster)</span>
    </a>
  ) : isEmbedded() ? (
    // In an iframe, navigate the parent window rather than the frame: the target
    // page is not embeddable and would be refused, leaving the frame blank.
    <a {...rest} href={props.url} target="_blank" rel={props.rel ? props.rel : 'noopener noreferrer'}>
      {children}
      <span className="sr-text">(Opent in nieuw venster)</span>
    </a>
  ) : (
    <InternalLink onClick={e => {window.scrollTo(0, 0); if (additionalOnClick != undefined) additionalOnClick(e)}} {...rest} to={props.url}>
      {children}
    </InternalLink>
  )
}
